/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Col,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  LoadingComponent,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import {
  rotaDayListAPI,
  showCarerEstimatehrsAPI,
  showClientEstimatehrsAPI,
  totalestimetedhrsAPI,
  trainingListAPI,
} from "./RotaTableData";
import { RotaOptions } from "../../../utils";
import { convertHexToColor } from "../../../utils/Functions";
import moment from "moment";
import RotaDetailModal, { ModalStatus } from "./RotaDetailModal";
import { GradeBadge } from "../../../components/badge/GradeBadge";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { RotaCopyJob } from "./Rotas";
import RotaEstimateModel from "./RotaEstimateModel";
import { HourBadge } from "../../../components/badge/StatusBadge";

export const RotaType = {
  hospital: "hospital",
  carer: "carer",
};

const RotaListing = ({
  carerId,
  clientId,
  type,
  startDate,
  endDate,
  showAll,
  gradeId,
  branchId,
  shiftType,
  agencyId,
  status,
  isSwitchOn,
}) => {
  const history = useHistory();
  const [rotaList, setRotaList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [detailModal, setDetailModal] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [estimateModal, setEstimateModal] = useState(false);
  const [totalRotaHours, setTotalRotaHours] = useState(0);
  const [clientdata, setClientdata] = useState({});
  function handleShowDetail(detail) {
    setDetailModal(true);
    setSelectedData(detail);
  }

  const onCopy = (row) => {
    history.push({
      pathname: `${process.env.PUBLIC_URL}/add-job`,
      state: { type: RotaCopyJob.isCopy, data: row },
    });
  };

  const onEdit = (row) => {
    history.push({
      pathname: `${process.env.PUBLIC_URL}/add-job`,
      state: { selectedTraining: row, type: RotaCopyJob.isTraining },
    });
  };

  const fetchData = async () => {
    try {
      if (currentPage !== 1) {
        setCurrentPage(1);
        return;
      }

      const [rotaData, trainingData] = await Promise.all([loadRotaAPI(), loadTrainingAPI()]);

      const combinedArray = [...rotaData, ...trainingData];

      if (type === RotaType.carer) {
        setRotaList(combinedArray);
      } else if (type === RotaType.hospital) {
        setRotaList(rotaData);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    gettotalEstimetedhours();
  }, [startDate, endDate, carerId, clientId, status, agencyId, branchId, gradeId, shiftType]);

  useEffect(() => {
    if (startDate && endDate) {
      fetchData();
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentPage === 1) {
      if (startDate && endDate) {
        fetchData();
      }
    } else {
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, startDate, endDate, carerId, showAll, clientId, type, gradeId, shiftType, agencyId, branchId]);

  function loadTrainingAPI() {
    return new Promise((resolve, reject) => {
      let params = {
        startDate,
        endDate,
        status: status === RotaOptions.open ? "ACTIVE" : status,
        carerId: carerId ?? 0,
      };

      trainingListAPI(params, (data, error) => {
        if (error === null) {
          resolve(data.list);
        } else {
          reject(error);
        }
      });
    });
  }

  function loadRotaAPI() {
    return new Promise((resolve, reject) => {
      if (!type && (!startDate || !endDate)) return resolve([]);
      if (loading) return resolve([]);

      let params = {
        startDate,
        endDate,
        branchId: branchId || null,
        gradeId: gradeId || null,
        shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
        status: status === RotaOptions.open ? "ACTIVE" : status,
        carerId: carerId ?? 0,
        clientId: clientId ?? 0,
        agencyId: agencyId ?? 0,
      };

      rotaDayListAPI(params, (data, error) => {
        if (error === null) {
          resolve(data.list);
        } else {
          reject(error);
        }
      });
    });
  }

  function gettotalEstimetedhours() {
    let params = {
      startDate: startDate,
      endDate: endDate,
      carerId: carerId ?? 0,
      clientId: clientId ?? 0,
      status: status === RotaOptions.open ? "ACTIVE" : status,
      agencyId: agencyId ?? 0,
      branchId: branchId ?? 0,
      gradeId: gradeId ?? 0,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
    };
    totalestimetedhrsAPI(params, (data, error) => {
      if (error === null) {
        setTotalRotaHours(data);
      }
      // setLoading(false);
    });
  }
  function showclientEstimatehoursList() {
    if (!carerId) return;
    let params = {
      carerId: carerId ?? 0,
      startDate: startDate,
      endDate: endDate,
      status: status === RotaOptions.open ? "ACTIVE" : status,
      agencyId: agencyId ?? 0,
      branchId: branchId ?? 0,
      gradeId: gradeId ?? 0,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
    };
    showClientEstimatehrsAPI(params, (data, error) => {
      if (error === null) {
        setClientdata(data);
      }
    });
  }
  function showcarerEstimatehoursList() {
    if (!clientId) return;
    let params = {
      clientId: clientId ?? 0,
      startDate: startDate,
      endDate: endDate,
      status: status === RotaOptions.open ? "ACTIVE" : status,
      agencyId: agencyId ?? 0,
      branchId: branchId ?? 0,
      gradeId: gradeId ?? 0,
      shiftType: shiftType?.value === "ANY" ? "" : shiftType?.value || null,
    };
    showCarerEstimatehrsAPI(params, (data, error) => {
      if (error === null) {
        setClientdata(data);
      }
    });
  }
  useEffect(() => {
    if (startDate && endDate) {
      showcarerEstimatehoursList();
    }
  }, [clientId, startDate, endDate, status, agencyId, branchId, gradeId, shiftType]);

  useEffect(() => {
    if (startDate && endDate) {
      showclientEstimatehoursList();
    }
  }, [carerId, startDate, endDate, status, agencyId, branchId, gradeId, shiftType]);

  const groupedRotas = [];
  rotaList.forEach((rota) => {
    const rotaDate = rota?.isTraining
      ? moment(rota?.startDate).format("DD-MM-YYYY")
      : moment(rota?.rotaDate).format("DD-MM-YYYY");
    const rotaDay = rota?.isTraining ? moment(rota?.startDate).format("dddd") : moment(rota?.rotaDate).format("dddd");
    const existingGroup = groupedRotas.find((group) => group.date === rotaDate);

    if (existingGroup) {
      let list = [...existingGroup.rotas];
      list.push(rota);
      const sortedList = list.sort((a, b) => moment(a.startTime) - moment(b.startTime));
      existingGroup.rotas = sortedList;
    } else {
      groupedRotas.push({ date: rotaDate, day: rotaDay, rotas: [rota] });
    }
  });

  const sortedRotas = groupedRotas.sort((a, b) => moment(a.date, "DD-MM-YYYY") - moment(b.date, "DD-MM-YYYY"));

  return (
    <>
      <PreviewAltCard className="h-100 w-100 overflow-auto">
        {rotaList?.length > 0 && !isSwitchOn && (
          <div className="flex justify-end mb-2 ">
            {totalRotaHours?.actualHours > 0 && (
              <span onClick={() => setEstimateModal(true)} className="text-primary cursor-pointer me-2">
                <HourBadge color={"primary"} text={`Actual hours: ${totalRotaHours?.actualHours?.toFixed(2)}`} />
              </span>
            )}

            {totalRotaHours?.estimateHours > 0 && (
              <span onClick={() => setEstimateModal(true)} className="text-success cursor-pointer">
                <HourBadge color={"success"} text={`Estimates hours: ${totalRotaHours?.estimateHours?.toFixed(2)}`} />
              </span>
            )}
          </div>
        )}
        <DataTable className={"mb-2"}>
          <DataTableBody>
            <DataTableHead>
              <DataTableRow className="border-bottom-0 rota-head-row">
                <Row>
                  <Col size={status === RotaOptions.cancelled ? 2 : 3}>
                    <span>Carer</span>
                  </Col>
                  <Col size={status === RotaOptions.cancelled ? 2 : 3}>
                    <span>Client</span>
                  </Col>
                  <Col size={status === RotaOptions.cancelled ? 2 : 3}>
                    <span>Grade</span>
                  </Col>
                  <Col size={2}>
                    <span className="ms-4">Start Time -End Time</span>
                  </Col>
                  {status === RotaOptions.cancelled && (
                    <>
                      <Col size="1">
                        <span className="">Cancelled By</span>
                      </Col>
                      <Col size="2">
                        <span className="ms-4">Cancelled Date</span>
                      </Col>
                    </>
                  )}
                  <Col size={1}>
                    <span className="ms-4"></span>
                  </Col>
                </Row>
              </DataTableRow>
            </DataTableHead>
          </DataTableBody>
        </DataTable>
        {sortedRotas.length > 0 ? (
          sortedRotas.map((group, groupIndex) => (
            <React.Fragment key={groupIndex}>
              <DataTable className="mb-2">
                <DataTableBody>
                  <DataTableHead>
                    <DataTableRow className=" fw-bold border-bottom text-black bg-light">
                      <span>
                        {group?.day} / {group?.date}
                      </span>
                    </DataTableRow>
                  </DataTableHead>
                  {group?.rotas?.map((rota, index) => (
                    <DataTableItem key={index} className="">
                      <DataTableRow>
                        <Row onClick={() => handleShowDetail(rota)} className="cursor-pointer align-items-center">
                          <Col size={status === RotaOptions.cancelled ? 2 : 3} className={"text-black"}>
                            <span>{rota?.carer}</span>
                          </Col>
                          <Col size={status === RotaOptions.cancelled ? 2 : 3} className={"text-black"}>
                            <span>{rota?.isTraining ? rota?.title : rota?.client?.name}</span>
                          </Col>
                          <Col size={status === RotaOptions.cancelled ? 2 : 3}>
                            <GradeBadge
                              label={rota?.grade?.name}
                              className={"me-1 my-1"}
                              color={`outline-${convertHexToColor(rota?.grade?.colourHex)}`}
                            />
                          </Col>
                          <Col size={2}>
                            <span className="ms-4">
                              {rota?.shiftType?.value && (
                                <img
                                  alt="#"
                                  style={{ width: "16px", height: "16px" }}
                                  src={
                                    rota?.shiftType?.value === "DAY"
                                      ? require("../../../assets/images/jsTree/shiftIcon/Sun.png")
                                      : require("../../../assets/images/jsTree/shiftIcon/Moon.png")
                                  }
                                  className="me-1"
                                />
                              )}
                              {moment(rota?.startTime).format("HH:mm")} - {moment(rota?.endTime).format("HH:mm")}
                            </span>
                          </Col>

                          {status === RotaOptions.cancelled && (
                            <>
                              <Col size={1}>
                                <span className="">{rota?.lastModifiedBy}</span>
                              </Col>
                              <Col size={2}>
                                <span className="ms-4"> {moment(rota?.lastModifiedDate).format("DD-MM-YYYY")}</span>
                              </Col>
                            </>
                          )}
                          <Col size={1} className="d-flex justify-content-end">
                            {rota?.isTraining ? (
                              <div className="job-edit-icon" onClick={() => onEdit(rota)}></div>
                            ) : (
                              <div className="job-copy-icon" onClick={() => onCopy(rota)}></div>
                            )}
                          </Col>
                        </Row>
                      </DataTableRow>
                    </DataTableItem>
                  ))}
                </DataTableBody>
              </DataTable>
            </React.Fragment>
          ))
        ) : (
          <div className=" text-center">There is no data found </div>
        )}
      </PreviewAltCard>
      <RotaEstimateModel visible={estimateModal} onClosed={(status) => setEstimateModal(false)} item={clientdata} />

      <RotaDetailModal
        visible={detailModal}
        rotaStatus={status}
        item={selectedData}
        onClosed={(status) => {
          if (status === ModalStatus.success) {
            loadRotaAPI();
          }
          setDetailModal(false);
        }}
      />
      <LoadingComponent isLoading={loading} />
    </>
  );
};

export default RotaListing;
